import React, { useState } from 'react'
import { Box, Button, FormControl, TextField, Typography } from '@mui/material'
import logo from '../../assets/Project_Images/App_logo.png'
import lock from '../../assets/Project_Images/Icons/Password.png'
import eye from '../../assets/Project_Images/Icons/eye.png'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from "yup"
import { Password } from '@mui/icons-material'
import { ApiCreateShopper, ApiResetPassword } from '../../apiService/Core/Apicall.tsx'
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../Loader/Loading.tsx'
import { hideLoading, showLoading } from '../../Redux/loadingSlice.tsx'
import { toast } from 'react-toastify'


interface FormValues {
    newpassword: string;
    confirmpassword: string;
}

const SetPassword: React.FC = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const loading = useSelector((state: any) => state.loader.isLoading);

    const [showpassword, setshowpassword] = useState<boolean>(false)
    const [showerror, setshowerror] = useState<boolean>(false);

    const [showpassword2, setshowpassword2] = useState<boolean>(false)
    const [strength, setStrength] = useState<string>("");
    const [strong, setStrong] = useState<number>(0);
    const navigate = useNavigate()
        const isForgot = location?.state?.isForgot
    const initialValues: FormValues = {
        newpassword: '',
        confirmpassword: '',
    }
    const keyup = (e: any) => {
        if (e.code === "Enter") {
            formik.handleSubmit();
        }
    };
    const onSubmit = async (values: FormValues) => {
        if (values.newpassword === values.confirmpassword) {

            const Apidata = {
                emailId: localStorage.getItem('emailId'),
                password: values.confirmpassword,
            }
            try {
                const response: any = isForgot ? await ApiResetPassword(Apidata):await ApiCreateShopper(Apidata);
                if (response.status) {
                    toast.success(response.message)
                    !isForgot && localStorage.setItem('token', response.token);
                    !isForgot && localStorage.setItem('userData', JSON.stringify(response.data));
                    localStorage.setItem('auth', '')
                    navigate( isForgot ?'/login':'/applicationform')
                }

            }
            catch (error) {
                 const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
            }
        }
        else {
            toast.error('password should be same')
        }
    }
    const validationSchema = Yup.object({
        newpassword: Yup.string().min(8, "Password must be at least 8 characters long").required("Password is required"),
        confirmpassword: Yup.string()
            .min(8, "Password must be at least 8 characters long")
            .required("Password is required"),
    });
    const formik = useFormik<FormValues>({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: false,
    })
    const passwordstrength = (event) => {
        const pass = event.target.value;
        formik.setFieldValue('newpassword', pass);
        if (pass.match(/(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])/)) {
            setStrength("Strong");
            setStrong(100);
        } else if (pass.match(/(?=.*[0-9])(?=.*[a-zA-Z])/)) {
            setStrength("Medium");
            setStrong(66);
        } else if (pass.match(/(?=.*[a-zA-Z])/)) {
            setStrength("Weak");
            setStrong(33);
        } else {
            // setStrength("weak");
            setStrong(0);
        }
    };
    return (
        <Box className='p-50-120 d-flex flex-column' height={{ xs: "80vh", sm: '100vh' }}>
            <Box component='img' className='col-md-4 col-6 mb-md-5 mb-5' src={logo} alt="" />
            <Box className='flex-grow-1' position='relative'>
                <Typography className='text-main fs-3 fw-bold'>Set Password</Typography>
                <Typography className='fs-18 w-100'>Set a strong password to keep your account and data safe.</Typography>
                <Box className='mt-5'>
                    <form onSubmit={formik.handleSubmit}>

                        <FormControl className='col-12 mb-3 mb-md-0'>
                            <TextField
                                type={showpassword ? 'text' : 'password'}
                                value={formik.values.newpassword}
                                onChange={(e) => { passwordstrength(e) }}
                                label={
                                    <span>
                                        New Password{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                slotProps={{
                                    input: {
                                        startAdornment: <Box component='img' src={lock} height='24px' width='24px' />,
                                        endAdornment: <Button onClick={() => { setshowpassword(!showpassword) }}><Box component='img' src={eye} height='24px' width='24px' /></Button>
                                    }
                                }}
                                InputLabelProps={{
                                    shrink: false,

                                }}
                            // {...formik.getFieldProps("newpassword")}
                            ></TextField>
                        </FormControl>
                        <Typography className="error ">
                            {showerror && formik.errors.newpassword ? (
                                <Typography className="error ">
                                    {formik.errors.newpassword}
                                </Typography>
                            ) : null}
                        </Typography>
                        <FormControl className='col-12'>
                            <TextField
                                type={showpassword2 ? 'text' : 'password'}

                                label={
                                    <span>
                                        Confirm Password{" "}
                                        <sup>
                                            <i
                                                className="fa-solid fa-star-of-life"
                                                style={{ color: "#fa0000", fontSize: "0.5rem" }}
                                            ></i>
                                        </sup>
                                    </span>
                                }

                                slotProps={{
                                    input: {
                                        startAdornment: <Box component='img' src={lock} height='24px' width='24px' />,
                                        endAdornment: <Button onClick={() => { setshowpassword2(!showpassword2) }}><Box component='img' src={eye} height='24px' width='24px' /></Button>
                                    }
                                }}
                                InputLabelProps={{
                                    shrink: false,

                                }}
                                {...formik.getFieldProps("confirmpassword")}

                            ></TextField>
                            <Typography className="error ">
                                {showerror && formik.errors.confirmpassword ? (
                                    <Typography className="error ">
                                        {formik.errors.confirmpassword}
                                    </Typography>
                                ) : null}
                            </Typography>
                            <Box
                                component="div" // Specify the component type
                                width='100%'
                                display='flex'
                                my='10px'
                                justifyContent='space-between'

                            >
                                <style>{
                                    `
                            progress::-webkit-progress-value {
                                        background-color: ${strong === 33 ? "red" : strong === 66 ? "orange" : ""
                                    } ; 
                            border-radius: 10px;
                                }
                            `}
                                </style>
                                <progress
                                    value={strong}
                                    max="25"
                                    className="progress border-50"
                                    style={{}}
                                ></progress>
                                <progress
                                    value={strong - 25}
                                    max="25"
                                    className="progress border-50"
                                ></progress>
                                <progress
                                    value={strong - 50}
                                    max="25"
                                    className="progress border-50"
                                ></progress>
                                <progress
                                    value={strong - 75}
                                    max="25"
                                    className="progress border-50"
                                ></progress>
                            </Box>
                            <Typography className="text-secondary">
                                Password Strength : {strength}
                            </Typography>
                        </FormControl>

                        <Button type='submit' onClick={() => setshowerror(true)} fullWidth className='button-primary mt-5'>Submit</Button>
                    </form>
                </Box>
            </Box>
            {loading && <Loading />}
        </Box>
    )
}

export default SetPassword
